export const defaultCardImgDimensions = {
  small: {
    width: 220,
  },
  medium: {
    width: 320,
  },
  large: {
    width: 400,
  },
}

export const modalCardImgDimensions = {
  ...defaultCardImgDimensions,
  large: defaultCardImgDimensions.medium,
}
